<deletemodal id="customer-tabs" [deleteModal]="clearPopup"></deletemodal>
<div class="main">
    <section class="container-fluid">
    </section>
    <div class="tab-content">
        <div role="tabpanel" class="tab-pane fade in active  padd-top-0" id="users">
            <form [formGroup]="ticketTypeForm" novalidate class="col-xs-12" (ngSubmit)="onSubmit(ticketTypeForm.valid)">
                <div class="page-heading">
                    <span>{{'config-system.Create Ticket Type' |translate}}</span>
                    <a class="backlink backuser-btn show">
                        <i class="fa fa-arrow-circle-left pad-r-8"></i>
                        <span [routerLink]="['/customerservice/configuration/search']" class="back-title"> {{'config-system.Back to Ticket Types' |translate}}</span>
                    </a>
                    <div class="pull-right pad-r-8">
                        <button *ngIf="!isUpdate" class="btn btn-add" type="submit">
                            <i class="fa fa-check pad-r-8"></i> {{'config-system.Create' |translate}}
                        </button>
                        <button *ngIf="isUpdate" class="btn btn-add" type="submit">
                            <i class="fa fa-check pad-r-8"></i> {{'config-system.Update' |translate}}
                        </button>
                        <button class="btn btn-add" type="button" (click)="clear()">
                            <i class="fa fa-close pad-r-8"></i> {{'config-system.Clear' |translate}}
                        </button>
                    </div>
                </div>
                <div class="title-underline"></div>
                <div class="card">
                    <div class="row">
                        <div class="form-group col-xs-12 col-sm-5 col-md-3">
                            <label>
                                {{'config-system.Operating Country' |translate}}
                                <span title="{{'config-system.Operating Country' |translate}}" class="ico-help fa fa-question-circle"></span>
                            </label>
                            <select class="form-control" formControlName="operatingCountryId">
                                <option value="">--Select--</option>
                                <option *ngFor="let country of operatingCountries | orderBy:'name'" [value]="country.id">{{country.name}}</option>
                            </select>
                            <div class="alert-msg" *ngIf="!ticketTypeForm.controls['operatingCountryId'].valid  && ticketTypeForm.controls['operatingCountryId'].hasError('required') && (ticketTypeForm.controls['operatingCountryId'].touched || isSubmitted)">
                                {{'validation-message.Operating Country is required'|translate}}</div>
                        </div>
                        <div class="form-group col-xs-12 col-sm-5 col-md-3">
                            <label>
                                {{'config-system.Ticket Type' |translate}}
                                <span title="{{'config-system.Ticket Type' |translate}}" class="ico-help fa fa-question-circle"></span>
                            </label>
                            <input type="text" class="form-control" formControlName="ticketType" placeholder="">
                            <div class="alert-msg" *ngIf="!ticketTypeForm.controls['ticketType'].valid  && ticketTypeForm.controls['ticketType'].hasError('required') && (ticketTypeForm.controls['ticketType'].touched || isSubmitted)">
                                {{'validation-message.Ticket Type is required'|translate}}</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/configuration/ticketType.component.html